import BackyardIcon from "@/assets/svg/BackyardIcon";
import PetIcon from "@/assets/svg/PetIcon";
import BalconyIcon from "@/assets/svg/BalconyIcon";
import GarageIcon from "@/assets/svg/GarageIcon";
import LaundryIcon from "@/assets/svg/LaundryIcon";
import FitnessIcon from "@/assets/svg/FitnessIcon";
import KitchenIcon from "@/assets/svg/KitchenIcon";
import BBQIcon from "@/assets/svg/BBQIcon";
import SwimmingPoolIcon from "@/assets/svg/SwimmingPoolIcon";
import CoveredCarParkIcon from "@/assets/svg/CoveredCarParkIcon";
import AirConditioningIcon from "@/assets/svg/AirConditioningIcon";
import WashingMachineIcon from "@/assets/svg/WashingMachineIcon";
import CookerHobIcon from "@/assets/svg/CookerHobIcon";
import WaterHeaterIcon from "@/assets/svg/WaterHeaterIcon";
import JacuzziIcon from "@/assets/svg/JacuzziIcon";
import SecurityIcon from "@/assets/svg/SecurityIcon";
import WadingPoolIcon from "@/assets/svg/WadingPoolIcon";
import ClubHouseIcon from "@/assets/svg/ClubHouseIcon";
import RetailStoreIcon from "@/assets/svg/RetailStoreIcon";
import SaunaIcon from "@/assets/svg/SaunaIcon";
import TennisCourtIcon from "@/assets/svg/TennisCourtIcon";
import BedIcon from "@/assets/svg/BedIcon";
import DiningRoomFurnitureIcon from "@/assets/svg/DiningRoomFurnitureIcon";
import MaidRoomIcon from "@/assets/svg/MaidRoomIcon";
import LivingRoomFurnitureIcon from "@/assets/svg/LivingRoomFurnitureIcon";
import FullyFurnishedIcon from "@/assets/svg/FullyFurnishedIcon";
import PartiallyFurnishedIcon from "@/assets/svg/PartiallyFurnishedIcon";
import MeetingRoomIcon from "@/assets/svg/MeetingRoomIcon";
import YogaIcon from "@/assets/svg/YogaIcon";
import PrivateLoungeIcon from "@/assets/svg/PrivateLoungeIcon";
import RestaurantIcon from "@/assets/svg/RestaurantIcon";
import CabanasIcon from "@/assets/svg/CabanasIcon";
import ChangingRoomIcon from "@/assets/svg/ChangingRoomIcon";
import HouseKeepingIcon from "@/assets/svg/HouseKeepingIcon";
import MobileHomeIcon from "@/assets/svg/MobileHomeIcon";
import FindPropertyIcon from "@/assets/svg/FindPropertyIcon";
import FreeListPropertyIcon from "@/assets/svg/FreeListPropertyIcon";
import SmileyFaceIcon from "@/assets/svg/SmileyFaceIcon";
import { getConfig } from "@/get-config";
// import ukFlag from "/public/flag/uk.png";

export const imgPath =
  "https://www.nar.realtor/_next/image?url=https%3A%2F%2Fcms.nar.realtor%2F%2Fsites%2Fdefault%2Ffiles%2F2024-09%2Flight-gray-house-with-for-sale-sign-on-lawn-GettyImages-82778239-1200w-628h.jpg%3Fitok%3DKckMk6-H&w=3840&q=75&dpl=dpl_DrgLdhdbGmnACQrtNsNUUXq7VRBM";

export const appUrl = "https://homesglobe.com";

export const IconComponent = {
  1: <BackyardIcon />,
  2: <KitchenIcon />,
  3: <GarageIcon />,
  4: <PetIcon />,
  5: <LaundryIcon />,
  6: <BalconyIcon />,
  7: <FitnessIcon />,
  8: <SwimmingPoolIcon />,
  9: <CookerHobIcon />,
  10: <AirConditioningIcon />,
  11: <WaterHeaterIcon />,
  12: <JacuzziIcon />,
  13: <SecurityIcon />,
  14: <CoveredCarParkIcon />,
  15: <WadingPoolIcon />,
  16: <ClubHouseIcon />,
  17: <WashingMachineIcon />,
  18: <RetailStoreIcon />,
  19: <SaunaIcon />,
  20: <TennisCourtIcon />,
  21: <BBQIcon />,
  22: <DiningRoomFurnitureIcon />,
  23: <BedIcon />,
  24: <KitchenIcon />,
  25: <MaidRoomIcon />,
  26: <LivingRoomFurnitureIcon />,
  27: <PartiallyFurnishedIcon />,
  28: <FullyFurnishedIcon />,
  29: <MeetingRoomIcon />,
  30: <ChangingRoomIcon />,
  31: <PrivateLoungeIcon />,
  32: <PrivateLoungeIcon />,
  33: <SwimmingPoolIcon />,
  34: <YogaIcon />,
  35: <CabanasIcon />,
  36: <RestaurantIcon />,
  37: <HouseKeepingIcon />
};

export const popoverNavItems = [
  {
    isButton: false,
    to: "/manage/dashboard",
    name: "common.dashboard"
  },
  {
    isButton: false,
    to: "/manage/add-property",
    name: "header.addProperty"
  },
  {
    isButton: false,
    to: "/manage/my-properties",
    name: "common.myProperties"
  },
  {
    isButton: false,
    to: "/manage/inbox",
    name: "common.inbox"
  },
  {
    isButton: false,
    to: "/manage/favorite",
    name: "common.favorite"
  },
  {
    isButton: false,
    to: "/manage/profile-settings",
    name: "header.profileSettings"
  },
  {
    isButton: true,
    to: "",
    name: "header.changePassword"
  }
];

export const navItems = [
  // TODO: update links
  {
    to: "/",
    name: "listingProperty.breadcrumbHome",
    icon: <MobileHomeIcon />
  },
  {
    to: "/property-listing",
    name: "nav.findAProperty",
    icon: <FindPropertyIcon />
  },
  {
    to: "/manage/add-property",
    name: "nav.listYourPropertyForFree",
    icon: <FreeListPropertyIcon />
  },
  {
    to: "/ai-agent-chat-bot",
    name: "nav.aiAgent",
    icon: <SmileyFaceIcon />
  },
  {
    to: "/market-insights",
    name: "nav.marketInsights",
    icon: <FreeListPropertyIcon />
  }
];

export const COMPANY_LINKS = [
  { to: "aboutUs", title: "footer.aboutUs" },
  { to: "contactUs", title: "footer.contactUs" },
  { to: "help-and-support", title: "footer.helpSupport" },
  { to: "terms-of-use", title: "footer.termsOfUse" },
  { to: "disclaimer", title: "footer.disclaimer" },
  { to: "privacyPolicy", title: "footer.privacyPolicy" }
];

export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/homesglobe/",
  facebook: "https://www.facebook.com/homesglobe",
  linkedin: "https://www.linkedin.com/company/homesglobe/",
  twitter: "https://x.com/homesglobe"
};

export const MAIL_TO = {
  footer: "mailto:hello@homesglobe.com"
};

export const currencyOptions = [
  { value: "$", label: "$" },
  { value: "€", label: "€" },
  { value: "£", label: "£" }
];

export const sizeOptions = [
  { value: "sq yard", label: "sq yard" },
  { value: "sq feet", label: "sq feet" },
  { value: "feet", label: "feet" },
  { value: "meters", label: "meters" }
];

export const getSizeOptions = (t) => [
  { value: "sq yard", label: t("common.areaUnits.sqYard") },
  { value: "sq feet", label: t("common.areaUnits.sqFeet") },
  { value: "feet", label: t("common.areaUnits.feet") },
  { value: "meters", label: t("common.areaUnits.meters") }
];

export const ComparisonTableLabels = [
  { label: "common.propertyType", key: "propertyListingType" },
  { label: "common.price", key: "price" },
  { label: "addProperty.year", key: "developmentYear" },
  { label: "common.homeType", key: "propertyHomeType" },
  { label: "common.propertySize", key: "propertySize" },
  { label: "compareProperties.noOfBath", key: "noBathroom" },
  { label: "compareProperties.noOfBed", key: "noBedroom" },
  { label: "compareProperties.noOfKitchen", key: "noKitchen" },
  { label: "compareProperties.yieldRate", key: "yieldRate" }
];

export const getPropertiesWorthOptions = (t) => [
  { value: "TOTAL", label: t("dashboard.allProperties") },
  { value: "SELL", label: t("dashboard.sell") },
  { value: "RENT", label: t("common.rent") },
  { value: "SOLD", label: t("dashboard.sold") }
];

export const countries = [
  {
    value: "Afghanistan",
    label: "Afghanistan"
  },
  {
    value: "Albania",
    label: "Albania"
  },
  {
    value: "Algeria",
    label: "Algeria"
  },
  {
    value: "American Samoa",
    label: "American Samoa"
  },
  {
    value: "Andorra",
    label: "Andorra"
  },
  {
    value: "Angola",
    label: "Angola"
  },
  {
    value: "Anguilla",
    label: "Anguilla"
  },
  {
    value: "Antigua & Barbuda",
    label: "Antigua & Barbuda"
  },
  {
    value: "Argentina",
    label: "Argentina"
  },
  {
    value: "Armenia",
    label: "Armenia"
  },
  {
    value: "Aruba",
    label: "Aruba"
  },
  {
    value: "Ascension Island",
    label: "Ascension Island"
  },
  {
    value: "Australia",
    label: "Australia"
  },
  {
    value: "Austria",
    label: "Austria"
  },
  {
    value: "Azerbaijan",
    label: "Azerbaijan"
  },
  {
    value: "Bahamas",
    label: "Bahamas"
  },
  {
    value: "Bahrain",
    label: "Bahrain"
  },
  {
    value: "Bangladesh",
    label: "Bangladesh"
  },
  {
    value: "Barbados",
    label: "Barbados"
  },
  {
    value: "Belarus",
    label: "Belarus"
  },
  {
    value: "Belgium",
    label: "Belgium"
  },
  {
    value: "Belize",
    label: "Belize"
  },
  {
    value: "Benin",
    label: "Benin"
  },
  {
    value: "Bermuda",
    label: "Bermuda"
  },
  {
    value: "Bhutan",
    label: "Bhutan"
  },
  {
    value: "Bolivia",
    label: "Bolivia"
  },
  {
    value: "Bosnia & Herzegovina",
    label: "Bosnia & Herzegovina"
  },
  {
    value: "Botswana",
    label: "Botswana"
  },
  {
    value: "Brazil",
    label: "Brazil"
  },
  {
    value: "British Indian Ocean Territory",
    label: "British Indian Ocean Territory"
  },
  {
    value: "British Virgin Islands",
    label: "British Virgin Islands"
  },
  {
    value: "Brunei",
    label: "Brunei"
  },
  {
    value: "Bulgaria",
    label: "Bulgaria"
  },
  {
    value: "Burkina Faso",
    label: "Burkina Faso"
  },
  {
    value: "Burundi",
    label: "Burundi"
  },
  {
    value: "Cambodia",
    label: "Cambodia"
  },
  {
    value: "Cameroon",
    label: "Cameroon"
  },
  {
    value: "Canada",
    label: "Canada"
  },
  {
    value: "Cape Verde",
    label: "Cape Verde"
  },
  {
    value: "Caribbean Netherlands",
    label: "Caribbean Netherlands"
  },
  {
    value: "Cayman Islands",
    label: "Cayman Islands"
  },
  {
    value: "Central African Republic",
    label: "Central African Republic"
  },
  {
    value: "Chad",
    label: "Chad"
  },
  {
    value: "Chile",
    label: "Chile"
  },
  {
    value: "China",
    label: "China"
  },
  {
    value: "Christmas Island",
    label: "Christmas Island"
  },
  {
    value: "Cocos (Keeling) Islands",
    label: "Cocos (Keeling) Islands"
  },
  {
    value: "Colombia",
    label: "Colombia"
  },
  {
    value: "Comoros",
    label: "Comoros"
  },
  {
    value: "Congo - Brazzaville",
    label: "Congo - Brazzaville"
  },
  {
    value: "Congo - Kinshasa",
    label: "Congo - Kinshasa"
  },
  {
    value: "Cook Islands",
    label: "Cook Islands"
  },
  {
    value: "Costa Rica",
    label: "Costa Rica"
  },
  {
    value: "Croatia",
    label: "Croatia"
  },
  {
    value: "Cuba",
    label: "Cuba"
  },
  {
    value: "Curaçao",
    label: "Curaçao"
  },
  {
    value: "Cyprus",
    label: "Cyprus"
  },
  {
    value: "Czechia",
    label: "Czechia"
  },
  {
    value: "Côte d’Ivoire",
    label: "Côte d’Ivoire"
  },
  {
    value: "Denmark",
    label: "Denmark"
  },
  {
    value: "Djibouti",
    label: "Djibouti"
  },
  {
    value: "Dominica",
    label: "Dominica"
  },
  {
    value: "Dominican Republic",
    label: "Dominican Republic"
  },
  {
    value: "Ecuador",
    label: "Ecuador"
  },
  {
    value: "Egypt",
    label: "Egypt"
  },
  {
    value: "El Salvador",
    label: "El Salvador"
  },
  {
    value: "Equatorial Guinea",
    label: "Equatorial Guinea"
  },
  {
    value: "Eritrea",
    label: "Eritrea"
  },
  {
    value: "Estonia",
    label: "Estonia"
  },
  {
    value: "Eswatini",
    label: "Eswatini"
  },
  {
    value: "Ethiopia",
    label: "Ethiopia"
  },
  {
    value: "Falkland Islands",
    label: "Falkland Islands"
  },
  {
    value: "Faroe Islands",
    label: "Faroe Islands"
  },
  {
    value: "Fiji",
    label: "Fiji"
  },
  {
    value: "Finland",
    label: "Finland"
  },
  {
    value: "France",
    label: "France"
  },
  {
    value: "French Guiana",
    label: "French Guiana"
  },
  {
    value: "French Polynesia",
    label: "French Polynesia"
  },
  {
    value: "Gabon",
    label: "Gabon"
  },
  {
    value: "Gambia",
    label: "Gambia"
  },
  {
    value: "Georgia",
    label: "Georgia"
  },
  {
    value: "Germany",
    label: "Germany"
  },
  {
    value: "Ghana",
    label: "Ghana"
  },
  {
    value: "Gibraltar",
    label: "Gibraltar"
  },
  {
    value: "Greece",
    label: "Greece"
  },
  {
    value: "Greenland",
    label: "Greenland"
  },
  {
    value: "Grenada",
    label: "Grenada"
  },
  {
    value: "Guadeloupe",
    label: "Guadeloupe"
  },
  {
    value: "Guam",
    label: "Guam"
  },
  {
    value: "Guatemala",
    label: "Guatemala"
  },
  {
    value: "Guernsey",
    label: "Guernsey"
  },
  {
    value: "Guinea",
    label: "Guinea"
  },
  {
    value: "Guinea-Bissau",
    label: "Guinea-Bissau"
  },
  {
    value: "Guyana",
    label: "Guyana"
  },
  {
    value: "Haiti",
    label: "Haiti"
  },
  {
    value: "Honduras",
    label: "Honduras"
  },
  {
    value: "Hong Kong SAR China",
    label: "Hong Kong SAR China"
  },
  {
    value: "Hungary",
    label: "Hungary"
  },
  {
    value: "Iceland",
    label: "Iceland"
  },
  {
    value: "India",
    label: "India"
  },
  {
    value: "Indonesia",
    label: "Indonesia"
  },
  {
    value: "Iran",
    label: "Iran"
  },
  {
    value: "Iraq",
    label: "Iraq"
  },
  {
    value: "Ireland",
    label: "Ireland"
  },
  {
    value: "Isle of Man",
    label: "Isle of Man"
  },
  {
    value: "Israel",
    label: "Israel"
  },
  {
    value: "Italy",
    label: "Italy"
  },
  {
    value: "Jamaica",
    label: "Jamaica"
  },
  {
    value: "Japan",
    label: "Japan"
  },
  {
    value: "Jersey",
    label: "Jersey"
  },
  {
    value: "Jordan",
    label: "Jordan"
  },
  {
    value: "Kazakhstan",
    label: "Kazakhstan"
  },
  {
    value: "Kenya",
    label: "Kenya"
  },
  {
    value: "Kiribati",
    label: "Kiribati"
  },
  {
    value: "Kosovo",
    label: "Kosovo"
  },
  {
    value: "Kuwait",
    label: "Kuwait"
  },
  {
    value: "Kyrgyzstan",
    label: "Kyrgyzstan"
  },
  {
    value: "Laos",
    label: "Laos"
  },
  {
    value: "Latvia",
    label: "Latvia"
  },
  {
    value: "Lebanon",
    label: "Lebanon"
  },
  {
    value: "Lesotho",
    label: "Lesotho"
  },
  {
    value: "Liberia",
    label: "Liberia"
  },
  {
    value: "Libya",
    label: "Libya"
  },
  {
    value: "Liechtenstein",
    label: "Liechtenstein"
  },
  {
    value: "Lithuania",
    label: "Lithuania"
  },
  {
    value: "Luxembourg",
    label: "Luxembourg"
  },
  {
    value: "Macao SAR China",
    label: "Macao SAR China"
  },
  {
    value: "Madagascar",
    label: "Madagascar"
  },
  {
    value: "Malawi",
    label: "Malawi"
  },
  {
    value: "Malaysia",
    label: "Malaysia"
  },
  {
    value: "Maldives",
    label: "Maldives"
  },
  {
    value: "Mali",
    label: "Mali"
  },
  {
    value: "Malta",
    label: "Malta"
  },
  {
    value: "Marshall Islands",
    label: "Marshall Islands"
  },
  {
    value: "Martinique",
    label: "Martinique"
  },
  {
    value: "Mauritania",
    label: "Mauritania"
  },
  {
    value: "Mauritius",
    label: "Mauritius"
  },
  {
    value: "Mayotte",
    label: "Mayotte"
  },
  {
    value: "Mexico",
    label: "Mexico"
  },
  {
    value: "Micronesia",
    label: "Micronesia"
  },
  {
    value: "Moldova",
    label: "Moldova"
  },
  {
    value: "Monaco",
    label: "Monaco"
  },
  {
    value: "Mongolia",
    label: "Mongolia"
  },
  {
    value: "Montenegro",
    label: "Montenegro"
  },
  {
    value: "Montserrat",
    label: "Montserrat"
  },
  {
    value: "Morocco",
    label: "Morocco"
  },
  {
    value: "Mozambique",
    label: "Mozambique"
  },
  {
    value: "Myanmar (Burma)",
    label: "Myanmar (Burma)"
  },
  {
    value: "Namibia",
    label: "Namibia"
  },
  {
    value: "Nauru",
    label: "Nauru"
  },
  {
    value: "Nepal",
    label: "Nepal"
  },
  {
    value: "Netherlands",
    label: "Netherlands"
  },
  {
    value: "New Caledonia",
    label: "New Caledonia"
  },
  {
    value: "New Zealand",
    label: "New Zealand"
  },
  {
    value: "Nicaragua",
    label: "Nicaragua"
  },
  {
    value: "Niger",
    label: "Niger"
  },
  {
    value: "Nigeria",
    label: "Nigeria"
  },
  {
    value: "Niue",
    label: "Niue"
  },
  {
    value: "Norfolk Island",
    label: "Norfolk Island"
  },
  {
    value: "North Korea",
    label: "North Korea"
  },
  {
    value: "North Macedonia",
    label: "North Macedonia"
  },
  {
    value: "Northern Mariana Islands",
    label: "Northern Mariana Islands"
  },
  {
    value: "Norway",
    label: "Norway"
  },
  {
    value: "Oman",
    label: "Oman"
  },
  {
    value: "Pakistan",
    label: "Pakistan"
  },
  {
    value: "Palau",
    label: "Palau"
  },
  {
    value: "Palestinian Territories",
    label: "Palestinian Territories"
  },
  {
    value: "Panama",
    label: "Panama"
  },
  {
    value: "Papua New Guinea",
    label: "Papua New Guinea"
  },
  {
    value: "Paraguay",
    label: "Paraguay"
  },
  {
    value: "Peru",
    label: "Peru"
  },
  {
    value: "Philippines",
    label: "Philippines"
  },
  {
    value: "Poland",
    label: "Poland"
  },
  {
    value: "Portugal",
    label: "Portugal"
  },
  {
    value: "Puerto Rico",
    label: "Puerto Rico"
  },
  {
    value: "Qatar",
    label: "Qatar"
  },
  {
    value: "Romania",
    label: "Romania"
  },
  {
    value: "Russia",
    label: "Russia"
  },
  {
    value: "Rwanda",
    label: "Rwanda"
  },
  {
    value: "Réunion",
    label: "Réunion"
  },
  {
    value: "Samoa",
    label: "Samoa"
  },
  {
    value: "San Marino",
    label: "San Marino"
  },
  {
    value: "Saudi Arabia",
    label: "Saudi Arabia"
  },
  {
    value: "Senegal",
    label: "Senegal"
  },
  {
    value: "Serbia",
    label: "Serbia"
  },
  {
    value: "Seychelles",
    label: "Seychelles"
  },
  {
    value: "Sierra Leone",
    label: "Sierra Leone"
  },
  {
    value: "Singapore",
    label: "Singapore"
  },
  {
    value: "Sint Maarten",
    label: "Sint Maarten"
  },
  {
    value: "Slovakia",
    label: "Slovakia"
  },
  {
    value: "Slovenia",
    label: "Slovenia"
  },
  {
    value: "Solomon Islands",
    label: "Solomon Islands"
  },
  {
    value: "Somalia",
    label: "Somalia"
  },
  {
    value: "South Africa",
    label: "South Africa"
  },
  {
    value: "South Korea",
    label: "South Korea"
  },
  {
    value: "South Sudan",
    label: "South Sudan"
  },
  {
    value: "Spain",
    label: "Spain"
  },
  {
    value: "Sri Lanka",
    label: "Sri Lanka"
  },
  {
    value: "St. Barthélemy",
    label: "St. Barthélemy"
  },
  {
    value: "St. Helena",
    label: "St. Helena"
  },
  {
    value: "St. Kitts & Nevis",
    label: "St. Kitts & Nevis"
  },
  {
    value: "St. Lucia",
    label: "St. Lucia"
  },
  {
    value: "St. Martin",
    label: "St. Martin"
  },
  {
    value: "St. Pierre & Miquelon",
    label: "St. Pierre & Miquelon"
  },
  {
    value: "St. Vincent & Grenadines",
    label: "St. Vincent & Grenadines"
  },
  {
    value: "Sudan",
    label: "Sudan"
  },
  {
    value: "Suriname",
    label: "Suriname"
  },
  {
    value: "Svalbard & Jan Mayen",
    label: "Svalbard & Jan Mayen"
  },
  {
    value: "Sweden",
    label: "Sweden"
  },
  {
    value: "Switzerland",
    label: "Switzerland"
  },
  {
    value: "Syria",
    label: "Syria"
  },
  {
    value: "São Tomé & Príncipe",
    label: "São Tomé & Príncipe"
  },
  {
    value: "Taiwan",
    label: "Taiwan"
  },
  {
    value: "Tajikistan",
    label: "Tajikistan"
  },
  {
    value: "Tanzania",
    label: "Tanzania"
  },
  {
    value: "Thailand",
    label: "Thailand"
  },
  {
    value: "Timor-Leste",
    label: "Timor-Leste"
  },
  {
    value: "Togo",
    label: "Togo"
  },
  {
    value: "Tokelau",
    label: "Tokelau"
  },
  {
    value: "Tonga",
    label: "Tonga"
  },
  {
    value: "Trinidad & Tobago",
    label: "Trinidad & Tobago"
  },
  {
    value: "Tristan da Cunha",
    label: "Tristan da Cunha"
  },
  {
    value: "Tunisia",
    label: "Tunisia"
  },
  {
    value: "Turkey",
    label: "Turkey"
  },
  {
    value: "Turkmenistan",
    label: "Turkmenistan"
  },
  {
    value: "Turks & Caicos Islands",
    label: "Turks & Caicos Islands"
  },
  {
    value: "Tuvalu",
    label: "Tuvalu"
  },
  {
    value: "U.S. Virgin Islands",
    label: "U.S. Virgin Islands"
  },
  {
    value: "Uganda",
    label: "Uganda"
  },
  {
    value: "Ukraine",
    label: "Ukraine"
  },
  {
    value: "United Arab Emirates",
    label: "United Arab Emirates"
  },
  {
    value: "United Kingdom",
    label: "United Kingdom"
  },
  {
    value: "United States",
    label: "United States"
  },
  {
    value: "Uruguay",
    label: "Uruguay"
  },
  {
    value: "Uzbekistan",
    label: "Uzbekistan"
  },
  {
    value: "Vanuatu",
    label: "Vanuatu"
  },
  {
    value: "Vatican City",
    label: "Vatican City"
  },
  {
    value: "Venezuela",
    label: "Venezuela"
  },
  {
    value: "Vietnam",
    label: "Vietnam"
  },
  {
    value: "Wallis & Futuna",
    label: "Wallis & Futuna"
  },
  {
    value: "Western Sahara",
    label: "Western Sahara"
  },
  {
    value: "Yemen",
    label: "Yemen"
  },
  {
    value: "Zambia",
    label: "Zambia"
  },
  {
    value: "Zimbabwe",
    label: "Zimbabwe"
  },
  {
    value: "Åland Islands",
    label: "Åland Islands"
  }
];
export const toolbarConfig = [
  [{ header: "1" }, { header: "2" }, { font: [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ align: [] }],
  ["bold", "italic", "underline"],
  ["link"],
  [{ color: [] }, { background: [] }],
  ["blockquote", "code-block"],
  ["emoji"]
];

export const notificationTypes = [
  "PROPERTY_PRICE_UPDATE_NOTIFICATION",
  "NEW_CHAT",
  "SUBSCRIPTION_PAYMENT_NOTIFICATION"
];
export const currencyLabels = [
  { value: "$", label: "$" },
  { value: "€", label: "€" },
  { value: "£", label: "£" }
];

export const getSortingLabels = (t) => [
  { value: "DESC", label: t("filter.newest") },
  { value: "ASC", label: t("filter.oldest") }
];

export const getPaymentSuccessMessage = (t) => ({
  message: t("payment.paymentSuccessTitle"),
  description: t("payment.paymentSuccessMessage"),
  placement: "topRight"
});

export const getPaymentCancelMessage = (t) => ({
  message: t("payment.paymentCancelledTitle"),
  description: t("payment.paymentCancelledMessage"),
  placement: "topRight"
});

export const propertyHomeTypesForDisableFields = ["LOTS_LANDS"];

export const localeMap = {
  en: "enUS",
  ar: "arEG",
  tr: "trTR",
  ru: "ruRU",
  fr: "frFR",
  es: "esES",
  zh: "zhCN"
};

export const rtlLanguages = ["ar", "ur", "fa"];

const { cdnAssetUrl } = getConfig();

const languageData = [
  { value: "en", labelCode: "EN", flagCode: "US", flagAlt: "United States" },
  { value: "ar", labelCode: "AR", flagCode: "SA", flagAlt: "Saudi Arabia" }, // Changed Alt for consistency
  { value: "tr", labelCode: "TR", flagCode: "TR", flagAlt: "Turkey" },
  { value: "ru", labelCode: "RU", flagCode: "RU", flagAlt: "Russia" },
  { value: "fr", labelCode: "FR", flagCode: "RE", flagAlt: "France" },
  { value: "es", labelCode: "ES", flagCode: "ES", flagAlt: "Spain" },
  { value: "zh", labelCode: "ZH", flagCode: "CN", flagAlt: "China" }
];

export const languageOptions = languageData.map(
  ({ value, flagCode, flagAlt, labelCode }) => {
    const flagSrc = `${cdnAssetUrl}${flagCode}.png`;

    return {
      value,
      label: (
        <div key={value} className="flex justify-between items-center">
          <img
            src={flagSrc}
            alt={flagAlt}
            // Consistent class application for size and spacing
            className="w-5 h-5 rounded-full object-cover mx-2"
          />
          <span className="flex-grow text-right">{labelCode}</span>
        </div>
      )
    };
  }
);

export const getTranslatedMonths = (t) => [
  t("months.jan"),
  t("months.feb"),
  t("months.mar"),
  t("months.apr"),
  t("months.may"),
  t("months.jun"),
  t("months.jul"),
  t("months.aug"),
  t("months.sep"),
  t("months.oct"),
  t("months.nov"),
  t("months.dec")
];

export const chips = [
  {
    icon: "🌆",
    label: "home.investmentAdvice",
    query: "home.investmentAdviceQuery"
  },
  {
    icon: "🎓",
    label: "home.legalAdvice",
    query: "home.legalAdviceQuery"
  },
  {
    icon: "🧠",
    label: "home.suggestProperty",
    query: "home.suggestPropertyQuery"
  },
  {
    icon: "📸",
    label: "home.analyseMarket",
    query: "home.analyseMarketQuery"
  }
];

export const propertyTypes = [
  { title: "common.forRent", value: "RENT" },
  { title: "common.forSell", value: "SELL" }
];

export const propertyTabs = [
  { key: "RENT", label: "common.rent" },
  { key: "SELL", label: "header.buy" }
];
